module.exports = __webpack_public_path__ + "img/neutral.1f8e98cd.gif";